import {
    Box,
    Paper,
    Typography,
    List,
    ListItem,
    ListItemText,
    Divider,
    ToggleButtonGroup,
    ToggleButton,
} from '@mui/material';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { Locale, selectSettings } from '../../settings/settingsSlice';
import { useAppSelector } from '../../../app/hooks';
import { VChainerFooter } from '../../../app/components/VChainerFooter';
import { useState } from 'react';
import { LanguageToggle } from '../../../app/components/LanguageToggle';


const texts = {
    title: {
        pl: 'Prośba o udostępnienie została wysłana',
        en: 'Access request has been sent',
        de: 'Zugriffsanfrage wurde gesendet',
    },
    detail: {
        pl: 'O udostępnienie dokumentu zostaniesz powiadomiony e‑mailem.',
        en: 'You will be notified by email about the document sharing. ',
        de: 'Sie werden per E-Mail benachrichtigt, sobald das Dokument freigegeben wurde.',
    },
};

export const DocumentAwaitingApprovalPanel = () => {
    const { locale } = useAppSelector(selectSettings);
    const [language, setLanguage] = useState<Locale>(locale);
    const lang = language === 'en-US' ? 'en' : language;

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="#f4f6f8"
            p={2}
        >
            <Paper
                elevation={4}
                sx={{
                    p: 5, maxWidth: 700, position: 'relative',
                    width: { xs: '94vw', sm: 500, md: 600 }, borderRadius: 3, textAlign: 'center'
                }}
            >
                <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
                    <LanguageToggle onChange={setLanguage} />
                </Box>
                <MarkEmailReadIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />

                <Typography variant="h5" gutterBottom>
                    {texts.title[lang]}
                </Typography>

                <List sx={{ textAlign: 'left', mb: 3 }}>
                    <ListItem>
                        <ListItemText primary={texts.detail[lang]} />
                    </ListItem>
                </List>

                <Divider />
                <VChainerFooter />
            </Paper>
        </Box>
    );
};
